import Card, { CardProps } from "@mui/material/Card";


const FdCard = ({ children, ...rest }: CardProps) => {
  
  return (
   <Card {...rest}>{children}</Card>
  );
};

export default FdCard;
